import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-email-verification-message',
  templateUrl: './email-verification-message.component.html',
  styleUrls: ['./email-verification-message.component.scss'],
})
export class EmailVerificationMessageComponent implements OnInit {
  email: string;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.params.pipe(take(1)).subscribe((param) => {
      this.email = param.email;
    });
  }
}
